module.exports = __webpack_public_path__ + "static/media/TeamPage.adda4960.png";